var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3DMovie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 300,
    viewBox: "0 0 66 66",
    width: 300,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m61.3 28.2h-45.5c0-.1-.1-.3-.1-.4 20.8-7.8 37.7-14.2 42.7-16 .5-.2.8-.8.6-1.3l-3.3-8.8c-.1-.3-.3-.5-.6-.6-.2-.1-.5-.1-.7 0l-48.3 18.1c-.5.2-.8.8-.6 1.3l1.3 3.4c-1.9 1.1-3.1 3-3.1 5.3 0 3 2.2 5.6 5.1 6v28.8c0 .6.4 1 1 1h51.6c.6 0 1-.4 1-1v-34.8c0-.6-.5-1-1.1-1zm-49.6 6.8-.9 1v-.8c.3 0 .6-.1.9-.2zm4.1-4.8h.2l-.3.3c.1-.1.1-.2.1-.3zm2.9 0h8.1l-6.7 7.4h-8.1zm10.8 0h8.1l-6.7 7.4h-8.1zm10.7 0h8.1l-6.7 7.4h-8.1zm10.8 0h8.1l-6.7 7.4h-8.1zm9.4 1.6v5.8h-5.2zm-47.6-7.9 2.3-6 7.6-2.8-3.6 9.3c-1.4.5-2.7 1-4.1 1.6-.6-.9-1.3-1.6-2.2-2.1zm26.5-7.1c-2.4.9-4.9 1.8-7.6 2.8l3.6-9.3 7.6-2.8zm6.1-10.2 7.6-2.9-3.7 9.3c-2.2.8-4.8 1.8-7.6 2.8zm-16.2 14c-2.4.9-5 1.9-7.6 2.8l3.6-9.3 7.6-2.8zm27.6-10.4c-1.2.5-2.9 1.1-4.9 1.8l2.9-7.3zm-49.1 10.5 4.9-1.8-1.7 4.3c-.4-.1-.8-.1-1.2-.1s-.8 0-1.1.1zm-2.1 8.5c0-2.3 1.9-4.1 4.1-4.1s4.1 1.9 4.1 4.1c0 2.3-1.9 4.1-4.1 4.1s-4.1-1.8-4.1-4.1zm5.2 33.8v-23.4h49.6v23.4z",
    fill: "#c72538ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.2 43.6c-10.7 0-32.6 0-43.3 0-.6 0-1 .4-1 1v4.9c0 .6.4 1 1 1h2.8v9.4c0 .6.4 1 1 1h12.3c.3 0 .5-.1.7-.3l3.3-3.3h3l3.3 3.3c.2.2.4.3.7.3h12.3c.6 0 1-.4 1-1v-9.4h2.8c.6 0 1-.4 1-1v-4.9c.1-.6-.3-1-.9-1zm-42.3 4.9v-2.9h1.8v2.9zm37.5 10.4h-10.9l-3.3-3.3c-.2-.2-.4-.3-.7-.3h-3.8c-.3 0-.5.1-.7.3l-3.3 3.3h-11v-13.3h33.7zm3.8-10.4h-1.8v-2.9h1.8z",
    fill: "#c72538ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.8 56.8h6.6c.3 0 .5-.1.7-.3l3.6-3.6c.2-.2.3-.4.3-.7v-3.7c0-.6-.4-1-1-1h-10.2c-.6 0-1 .4-1 1v7.3c0 .6.4 1 1 1zm1-7.2h8.2v2.3l-3 3h-5.2z",
    fill: "#c72538ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 56.6c.2.2.4.3.7.3h6.6c.6 0 1-.4 1-1v-7.3c0-.6-.4-1-1-1h-10.2c-.6 0-1 .4-1 1v3.7c0 .3.1.5.3.7zm-1.9-7h8.2v5.3h-5.2l-3-3z",
    fill: "#c72538ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DMovie);
export default __webpack_public_path__ + "static/media/3d-movie.8723b54096ab12680845a466eaea2b1f.svg";
export { ForwardRef as ReactComponent };